var map = {
	"./App": 72998,
	"./App.vue": 72998,
	"./assets/css/anim.scss": 98570,
	"./assets/css/common.scss": 90807,
	"./assets/css/global.scss": 23059,
	"./assets/css/reset.scss": 12841,
	"./assets/css/utils.scss": 55955,
	"./assets/css/vtip.css": 96714,
	"./assets/fonts/HARMONYOS_SANS_BOLD.TTF": 35981,
	"./assets/fonts/HARMONYOS_SANS_MEDIUM.TTF": 14514,
	"./assets/fonts/HARMONYOS_SANS_REGULAR.TTF": 39773,
	"./assets/fonts/font.css": 39399,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/icon-Increase.svg": 43264,
	"./assets/icons/svg/icon-arrow.svg": 51089,
	"./assets/icons/svg/icon-close.svg": 50829,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-telegram.svg": 45810,
	"./assets/icons/svg/icon-time.svg": 94375,
	"./assets/icons/svg/icon-twitter.svg": 65765,
	"./assets/icons/svg/icon-warn.svg": 7292,
	"./assets/icons/svg/loading.svg": 66859,
	"./assets/images/card/p0101.png": 92819,
	"./assets/images/card/p0102.png": 52893,
	"./assets/images/card/p0103.png": 17066,
	"./assets/images/card/p0104.png": 68485,
	"./assets/images/card/p0201.png": 30175,
	"./assets/images/card/p0202.png": 75389,
	"./assets/images/card/p0301.png": 59117,
	"./assets/images/card/p0302.png": 45125,
	"./assets/images/card/p0303.png": 20590,
	"./assets/images/card/p0304.png": 39733,
	"./assets/images/card/p0401.png": 90442,
	"./assets/images/card/p0402.png": 77793,
	"./assets/images/card/p0403.png": 53781,
	"./assets/images/card/p0404.png": 75983,
	"./assets/images/card/p0501.png": 58546,
	"./assets/images/card/p0502.png": 50356,
	"./assets/images/card/p0503.png": 9023,
	"./assets/images/card/p0504.png": 12352,
	"./assets/images/card/p0601.png": 15029,
	"./assets/images/card/p0602.png": 31234,
	"./assets/images/card/p0603.png": 79675,
	"./assets/images/card/p0604.png": 61339,
	"./assets/images/card/p0701.png": 96163,
	"./assets/images/card/p0702.png": 92186,
	"./assets/images/card/p0703.png": 42551,
	"./assets/images/card/p0704.png": 83303,
	"./assets/images/card/p0801.png": 46659,
	"./assets/images/card/p0802.png": 30922,
	"./assets/images/card/p0803.png": 18878,
	"./assets/images/card/p0804.png": 52228,
	"./assets/images/card/p0901.png": 5242,
	"./assets/images/card/p0902.png": 22961,
	"./assets/images/card/p1001.png": 47522,
	"./assets/images/card/p1002.png": 50566,
	"./assets/images/card/p1003.png": 37869,
	"./assets/images/card/p1004.png": 30802,
	"./assets/images/card/p1101.png": 59756,
	"./assets/images/card/p1102.png": 40124,
	"./assets/images/card/p1103.png": 28115,
	"./assets/images/card/p1104.png": 59587,
	"./assets/images/card/p1201.png": 6669,
	"./assets/images/card/p1202.png": 85803,
	"./assets/images/card/p1301.png": 39112,
	"./assets/images/card/p1302.png": 2557,
	"./assets/images/card/p1303.png": 53036,
	"./assets/images/card/p1304.png": 70582,
	"./assets/images/card/p1401.png": 26624,
	"./assets/images/card/p1402.png": 52199,
	"./assets/images/card/p1501.png": 61960,
	"./assets/images/card/p1502.png": 39753,
	"./assets/images/lists/p0101.jpg": 95154,
	"./assets/images/lists/p0102.jpg": 14386,
	"./assets/images/lists/p0103.jpg": 43546,
	"./assets/images/lists/p0104.jpg": 63008,
	"./assets/images/lists/p0201.jpg": 13959,
	"./assets/images/lists/p0202.jpg": 81979,
	"./assets/images/lists/p0301.jpg": 3746,
	"./assets/images/lists/p0302.jpg": 16565,
	"./assets/images/lists/p0303.jpg": 71315,
	"./assets/images/lists/p0304.jpg": 26643,
	"./assets/images/lists/p0401.jpg": 13582,
	"./assets/images/lists/p0402.jpg": 39336,
	"./assets/images/lists/p0403.jpg": 43113,
	"./assets/images/lists/p0404.jpg": 74234,
	"./assets/images/lists/p0501.jpg": 80170,
	"./assets/images/lists/p0502.jpg": 4022,
	"./assets/images/lists/p0503.jpg": 84047,
	"./assets/images/lists/p0504.jpg": 19490,
	"./assets/images/lists/p0601.jpg": 55638,
	"./assets/images/lists/p0602.jpg": 48443,
	"./assets/images/lists/p0603.jpg": 63293,
	"./assets/images/lists/p0604.jpg": 78531,
	"./assets/images/lists/p0701.jpg": 68937,
	"./assets/images/lists/p0702.jpg": 19953,
	"./assets/images/lists/p0703.jpg": 90472,
	"./assets/images/lists/p0704.jpg": 64934,
	"./assets/images/lists/p0801.jpg": 77932,
	"./assets/images/lists/p0802.jpg": 83187,
	"./assets/images/lists/p0803.jpg": 87168,
	"./assets/images/lists/p0804.jpg": 93874,
	"./assets/images/lists/p0901.jpg": 7573,
	"./assets/images/lists/p0902.jpg": 31760,
	"./assets/images/lists/p1001.jpg": 64643,
	"./assets/images/lists/p1002.jpg": 90079,
	"./assets/images/lists/p1003.jpg": 26665,
	"./assets/images/lists/p1004.jpg": 29809,
	"./assets/images/lists/p1101.jpg": 43339,
	"./assets/images/lists/p1102.jpg": 98137,
	"./assets/images/lists/p1103.jpg": 6878,
	"./assets/images/lists/p1104.jpg": 90264,
	"./assets/images/lists/p1201.jpg": 54661,
	"./assets/images/lists/p1202.jpg": 90349,
	"./assets/images/lists/p1301.jpg": 3114,
	"./assets/images/lists/p1302.jpg": 25261,
	"./assets/images/lists/p1303.jpg": 14606,
	"./assets/images/lists/p1304.jpg": 63298,
	"./assets/images/lists/p1401.jpg": 94036,
	"./assets/images/lists/p1402.jpg": 7004,
	"./assets/images/lists/p1501.jpg": 1790,
	"./assets/images/lists/p1502.jpg": 72678,
	"./assets/images/ui/activity-bg.jpg": 93942,
	"./assets/images/ui/activity-gift.png": 34947,
	"./assets/images/ui/airdrop-bg.jpg": 96339,
	"./assets/images/ui/airdrop-invite.png": 63821,
	"./assets/images/ui/airdrop-status-ended.png": 86853,
	"./assets/images/ui/airdrop-status-notStarted.png": 87142,
	"./assets/images/ui/airdrop-status-pedding.png": 46570,
	"./assets/images/ui/airdrop-status-prizedrawm.png": 18531,
	"./assets/images/ui/airdrop-time.png": 55355,
	"./assets/images/ui/arena-head-bg.jpg": 61518,
	"./assets/images/ui/arena-head-left.png": 53629,
	"./assets/images/ui/arena-head-right.png": 52012,
	"./assets/images/ui/arena-head-s.png": 45065,
	"./assets/images/ui/arena-head-v.png": 70375,
	"./assets/images/ui/assets-bg.jpg": 39676,
	"./assets/images/ui/award_tip.png": 96062,
	"./assets/images/ui/battle-bg.jpg": 61475,
	"./assets/images/ui/battle-defeat-bg.png": 72834,
	"./assets/images/ui/battle-head-attack-bg.png": 94628,
	"./assets/images/ui/battle-head-defender-bg.png": 95658,
	"./assets/images/ui/battle-head-vs.png": 79395,
	"./assets/images/ui/battle-icon-honor.png": 67051,
	"./assets/images/ui/battle-icon-power.png": 57727,
	"./assets/images/ui/battle-record-icon-defeat.png": 70325,
	"./assets/images/ui/battle-record-icon-victory.png": 58176,
	"./assets/images/ui/battle-victory-bg.png": 56616,
	"./assets/images/ui/battle-victory-crown.png": 9791,
	"./assets/images/ui/battle-victory-ribbon.png": 4493,
	"./assets/images/ui/battle-victory-text.png": 80590,
	"./assets/images/ui/battle-victory-wing.png": 54943,
	"./assets/images/ui/battleEffect/0.png": 61336,
	"./assets/images/ui/battleEffect/1.png": 13889,
	"./assets/images/ui/battleEffect/2.png": 3347,
	"./assets/images/ui/btn-activity-bg.png": 53669,
	"./assets/images/ui/btn-airdrop-bg.png": 59540,
	"./assets/images/ui/btn-airdrop.png": 85135,
	"./assets/images/ui/btn-close.png": 81554,
	"./assets/images/ui/btn-draw-1-bg.png": 81405,
	"./assets/images/ui/btn-draw-2-bg.png": 34557,
	"./assets/images/ui/btn-draw-3-bg.png": 23192,
	"./assets/images/ui/btn-draw-one.png": 6219,
	"./assets/images/ui/btn-draw-ten.png": 66006,
	"./assets/images/ui/btn-join-bg.png": 51838,
	"./assets/images/ui/btn-jump.png": 67643,
	"./assets/images/ui/btn-mint.png": 74765,
	"./assets/images/ui/btn-pay-bg.png": 56758,
	"./assets/images/ui/btn-pay-diamond-info.png": 43680,
	"./assets/images/ui/btn-shop-bg.png": 69565,
	"./assets/images/ui/btn-task-bg.png": 88633,
	"./assets/images/ui/btn-upgrade-bg.png": 60186,
	"./assets/images/ui/btn-upgrade-star-bg.png": 91594,
	"./assets/images/ui/card-back.png": 46269,
	"./assets/images/ui/chip-1.png": 87422,
	"./assets/images/ui/chip.png": 55531,
	"./assets/images/ui/daily-icon-card.png": 28086,
	"./assets/images/ui/daily-icon-info.png": 89714,
	"./assets/images/ui/daily-icon-ok.png": 46281,
	"./assets/images/ui/daily-signed-bg.jpg": 12954,
	"./assets/images/ui/daily-today-bg.jpg": 56683,
	"./assets/images/ui/detail-bg.jpg": 50518,
	"./assets/images/ui/diamond-1.png": 1909,
	"./assets/images/ui/diamond-2.png": 33627,
	"./assets/images/ui/diamond-3.png": 92003,
	"./assets/images/ui/diamond-4.png": 91993,
	"./assets/images/ui/enery_invite.png": 60547,
	"./assets/images/ui/friend-bg.jpg": 49775,
	"./assets/images/ui/friend-btn-copy.png": 39114,
	"./assets/images/ui/friend-btn-invite.png": 57443,
	"./assets/images/ui/friend-item-bg.jpg": 65951,
	"./assets/images/ui/guide-hand.png": 46760,
	"./assets/images/ui/icon-ads.png": 32007,
	"./assets/images/ui/icon-airdop-invite.png": 18861,
	"./assets/images/ui/icon-airdrop.png": 47003,
	"./assets/images/ui/icon-anim-upgrade.png": 91082,
	"./assets/images/ui/icon-anim-upgrade_1.png": 24292,
	"./assets/images/ui/icon-arena-filter.png": 10646,
	"./assets/images/ui/icon-arena-lock.png": 32506,
	"./assets/images/ui/icon-arena-power.png": 17877,
	"./assets/images/ui/icon-arena-record.png": 71527,
	"./assets/images/ui/icon-arena.png": 93876,
	"./assets/images/ui/icon-copy.png": 50710,
	"./assets/images/ui/icon-diamonds.png": 26987,
	"./assets/images/ui/icon-energy.png": 78163,
	"./assets/images/ui/icon-gold.png": 16404,
	"./assets/images/ui/icon-info.png": 90563,
	"./assets/images/ui/icon-invite.png": 90142,
	"./assets/images/ui/icon-mint.png": 34464,
	"./assets/images/ui/icon-pay.png": 74084,
	"./assets/images/ui/icon-power-new.png": 70946,
	"./assets/images/ui/icon-power.png": 45668,
	"./assets/images/ui/icon-question.png": 81433,
	"./assets/images/ui/icon-quit.png": 56423,
	"./assets/images/ui/icon-ranking.png": 27976,
	"./assets/images/ui/icon-record.png": 79325,
	"./assets/images/ui/icon-shop.png": 92062,
	"./assets/images/ui/icon-task.png": 88515,
	"./assets/images/ui/icon-time.png": 45747,
	"./assets/images/ui/icon-ton.png": 48514,
	"./assets/images/ui/icon-usdt.png": 22130,
	"./assets/images/ui/icon-wallet.png": 98418,
	"./assets/images/ui/item-bg.png": 86269,
	"./assets/images/ui/item-level.png": 26714,
	"./assets/images/ui/join-g.png": 3391,
	"./assets/images/ui/light.png": 89937,
	"./assets/images/ui/menu-arena-active1.png": 88422,
	"./assets/images/ui/menu-arena.png": 60742,
	"./assets/images/ui/menu-assets-active1.png": 34854,
	"./assets/images/ui/menu-assets.png": 39699,
	"./assets/images/ui/menu-backpack-active1.png": 98719,
	"./assets/images/ui/menu-backpack.png": 32911,
	"./assets/images/ui/menu-friend-active1.png": 22359,
	"./assets/images/ui/menu-friend.png": 20860,
	"./assets/images/ui/menu-home-active1.png": 3098,
	"./assets/images/ui/menu-home.png": 95847,
	"./assets/images/ui/menu-mining-active1.png": 70331,
	"./assets/images/ui/menu-mining.png": 24539,
	"./assets/images/ui/menu-rank-active1.png": 5365,
	"./assets/images/ui/menu-rank.png": 20918,
	"./assets/images/ui/mining/logo/binance.png": 27528,
	"./assets/images/ui/mining/logo/bitget.png": 13230,
	"./assets/images/ui/mining/logo/gate.png": 16745,
	"./assets/images/ui/mining/logo/okx.png": 25078,
	"./assets/images/ui/mining/logo/stonfi.png": 37696,
	"./assets/images/ui/mining/mining-head-img.jpg": 91662,
	"./assets/images/ui/mining/mining-q-1.jpg": 89786,
	"./assets/images/ui/mining/mining-q-1.png": 67973,
	"./assets/images/ui/mining/mining-q-2.png": 90082,
	"./assets/images/ui/mining/mining-q-3.png": 24831,
	"./assets/images/ui/mining/mining-q-4.png": 33338,
	"./assets/images/ui/mining/mining-q-5.png": 46265,
	"./assets/images/ui/name-bg.png": 20111,
	"./assets/images/ui/nav-btn-bg-1.png": 21829,
	"./assets/images/ui/nav-btn-bg-2.png": 17809,
	"./assets/images/ui/nav-btn-bg-3.png": 67157,
	"./assets/images/ui/nav-btn-bg-4.png": 66227,
	"./assets/images/ui/pony.png": 39467,
	"./assets/images/ui/ponyverse.png": 28383,
	"./assets/images/ui/pop-btn-upgrade-bg.png": 36521,
	"./assets/images/ui/pop-btn-upgrade-star-bg.png": 27631,
	"./assets/images/ui/pop-upgrade-arrow.png": 17091,
	"./assets/images/ui/pop-upgradestar-star-bg.png": 71262,
	"./assets/images/ui/popPayDiamondInfo.jpg": 33919,
	"./assets/images/ui/rank-1.png": 84089,
	"./assets/images/ui/rank-2.png": 987,
	"./assets/images/ui/rank-3.png": 27269,
	"./assets/images/ui/rank-head-bg.jpg": 41554,
	"./assets/images/ui/rarity-1.png": 29030,
	"./assets/images/ui/rarity-2.png": 45760,
	"./assets/images/ui/rarity-3.png": 12668,
	"./assets/images/ui/rarity-4.png": 53777,
	"./assets/images/ui/rarity-5.png": 91389,
	"./assets/images/ui/rarity-bg.png": 78347,
	"./assets/images/ui/rarity-text-1.png": 90363,
	"./assets/images/ui/rarity-text-2.png": 59497,
	"./assets/images/ui/rarity-text-3.png": 1183,
	"./assets/images/ui/rarity-text-4.png": 38987,
	"./assets/images/ui/rarity-text-5.png": 42662,
	"./assets/images/ui/reward-card-img.png": 39393,
	"./assets/images/ui/reward-coin-img.png": 64758,
	"./assets/images/ui/reward-coin-question.png": 72346,
	"./assets/images/ui/reward-icon-watch.png": 94117,
	"./assets/images/ui/reward-pony-img.png": 50965,
	"./assets/images/ui/reward-usdt-img.png": 1089,
	"./assets/images/ui/shop-bg.jpg": 46613,
	"./assets/images/ui/star-bg.png": 37773,
	"./assets/images/ui/star.png": 94008,
	"./assets/images/ui/task-img.jpg": 37495,
	"./assets/js/assetsManifest": 55715,
	"./assets/js/assetsManifest.json": 55715,
	"./assets/js/eventBus": 1093,
	"./assets/js/eventBus.js": 1093,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/pop": 42487,
	"./assets/js/pop.js": 42487,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./assets/js/requestApiCache": 91270,
	"./assets/js/requestApiCache.js": 91270,
	"./components/layout": 13386,
	"./components/layout.vue": 13386,
	"./components/mAirdropRankItem": 84229,
	"./components/mAirdropRankItem.vue": 84229,
	"./components/mArenaAssets": 34978,
	"./components/mArenaAssets.vue": 34978,
	"./components/mAssets": 14780,
	"./components/mAssets.vue": 14780,
	"./components/mCardItem": 6538,
	"./components/mCardItem.vue": 6538,
	"./components/mDaily": 41210,
	"./components/mDaily.vue": 41210,
	"./components/mDiamondItem": 20886,
	"./components/mDiamondItem.vue": 20886,
	"./components/mEmpty": 35857,
	"./components/mEmpty.vue": 35857,
	"./components/mMenu": 40408,
	"./components/mMenu.vue": 40408,
	"./components/mNav": 82661,
	"./components/mNav.vue": 82661,
	"./components/mPage": 43294,
	"./components/mPage.vue": 43294,
	"./components/mRankItem": 33372,
	"./components/mRankItem.vue": 33372,
	"./components/mTask": 26688,
	"./components/mTask.vue": 26688,
	"./components/popActivateCard": 35313,
	"./components/popActivateCard.vue": 35313,
	"./components/popAddEnergy": 19164,
	"./components/popAddEnergy.vue": 19164,
	"./components/popBattleResult": 39489,
	"./components/popBattleResult.vue": 39489,
	"./components/popComingSoon": 7964,
	"./components/popComingSoon.vue": 7964,
	"./components/popGuide": 83801,
	"./components/popGuide.vue": 83801,
	"./components/popIncome": 67820,
	"./components/popIncome.vue": 67820,
	"./components/popJoinArena": 6221,
	"./components/popJoinArena.vue": 6221,
	"./components/popJoinArenaSelectAmount": 45056,
	"./components/popJoinArenaSelectAmount.vue": 45056,
	"./components/popLuckyAirdropInfo": 99598,
	"./components/popLuckyAirdropInfo.vue": 99598,
	"./components/popPayDiamondInfo": 62814,
	"./components/popPayDiamondInfo.vue": 62814,
	"./components/popPayReward": 71514,
	"./components/popPayReward.vue": 71514,
	"./components/popPickCombination": 19846,
	"./components/popPickCombination.vue": 19846,
	"./components/popPrompt": 46132,
	"./components/popPrompt.vue": 46132,
	"./components/popReward": 45509,
	"./components/popReward.vue": 45509,
	"./components/popUpgrade": 2677,
	"./components/popUpgrade.vue": 2677,
	"./components/popUpgradestar": 28369,
	"./components/popUpgradestar.vue": 28369,
	"./components/preloadImage": 69888,
	"./components/preloadImage.vue": 69888,
	"./components/svgIcon": 40179,
	"./components/svgIcon.vue": 40179,
	"./components/toolTip": 67759,
	"./components/toolTip.vue": 67759,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./mixins/anim": 82568,
	"./mixins/anim.js": 82568,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/game": 52983,
	"./store/modules/game.js": 52983,
	"./store/modules/user": 69220,
	"./store/modules/user.js": 69220,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 88929,
	"./tonWallet/": 88929,
	"./tonWallet/config/config": 73649,
	"./tonWallet/config/config.json": 73649,
	"./tonWallet/config_for_test/config": 46398,
	"./tonWallet/config_for_test/config.json": 46398,
	"./tonWallet/index": 88929,
	"./tonWallet/index.js": 88929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 55583,
	"./view/": 55583,
	"./view/airdrop": 69796,
	"./view/airdrop.vue": 69796,
	"./view/arena": 43594,
	"./view/arena.vue": 43594,
	"./view/assets": 33557,
	"./view/assets.vue": 33557,
	"./view/battle": 50839,
	"./view/battle.vue": 50839,
	"./view/battleRecord": 25795,
	"./view/battleRecord.vue": 25795,
	"./view/battleTest": 5342,
	"./view/battleTest.vue": 5342,
	"./view/detail": 71932,
	"./view/detail.vue": 71932,
	"./view/diamond": 17128,
	"./view/diamond.vue": 17128,
	"./view/friend": 45311,
	"./view/friend.vue": 45311,
	"./view/index": 55583,
	"./view/index.vue": 55583,
	"./view/mining": 79831,
	"./view/mining.vue": 79831,
	"./view/rank": 58314,
	"./view/rank.vue": 58314,
	"./view/shop": 57251,
	"./view/shop.vue": 57251,
	"./view/task": 12937,
	"./view/task.vue": 12937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;